const keyPrefix = 'FASIT_SUMMA_PREVIEW_MODEL_';

// The model is kept rather than a yes, so a later coming model is never tried without the superuser choosing it.
export function readPreviewModel(userId?: string) {
  if (!userId) {
    return undefined;
  }

  try {
    return localStorage.getItem(`${keyPrefix}${userId}`) ?? undefined;
  } catch {
    return undefined;
  }
}

export function storePreviewModel(userId: string | undefined, model: string | undefined) {
  if (!userId) {
    return;
  }

  try {
    if (model) {
      localStorage.setItem(`${keyPrefix}${userId}`, model);
    } else {
      localStorage.removeItem(`${keyPrefix}${userId}`);
    }
  } catch {
    // Without storage the choice simply falls back to off next time.
  }
}
